/**
 * TimeRuler — Horizontal time axis with ticks and labels
 */
import { useMemo } from 'react';
import { generateTicks, type TimeScale } from '../../utils/timelineUtils';

interface TimeRulerProps {
  scale: TimeScale;
  height?: number;
}

export default function TimeRuler({ scale, height = 32 }: TimeRulerProps) {
  const ticks = useMemo(() => generateTicks(scale), [scale]);

  return (
    <svg
      className="vst-time-ruler"
      width={scale.widthPx}
      height={height}
      style={{ display: 'block' }}
    >
      {/* Background */}
      <rect width={scale.widthPx} height={height} fill="#1f2937" />

      {/* Bottom line */}
      <line
        x1={0}
        y1={height - 1}
        x2={scale.widthPx}
        y2={height - 1}
        stroke="#374151"
        strokeWidth={1}
      />

      {ticks.map(tick => (
        <g key={tick.ms}>
          <line
            x1={tick.x}
            y1={tick.isMajor ? height - 16 : height - 8}
            x2={tick.x}
            y2={height - 1}
            stroke={tick.isMajor ? '#9ca3af' : '#4b5563'}
            strokeWidth={tick.isMajor ? 1 : 0.5}
          />
          {tick.isMajor && (
            <text
              x={tick.x}
              y={height - 19}
              fill="#d1d5db"
              fontSize={11}
              textAnchor="middle"
              fontFamily="monospace"
            >
              {tick.label}
            </text>
          )}
        </g>
      ))}
    </svg>
  );
}
